// extracted by mini-css-extract-plugin
module.exports = {"slide":"__________Mobile_slide__61PA4"};